import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ObjectEntity } from './object.entity';

@Index('_fk__object__id', ['fkObjectId'], {})
@Index('import_export_alias', ['alias', 'type'], { unique: true })
@Entity('_import_export_store')
export class ImportExportStoreEntity extends BaseEntity {
	@Column('varchar', { name: '_name', length: 255 })
	public name!: string;

	@Column('varchar', { name: '_alias', length: 50 })
	public alias!: string;

	@Column('varchar', { name: '_type', length: 15 })
	public type!: string;

	@Column('text', { name: '_definition' })
	public definition!: string;

	@Column('int', { name: '_fk__object__id', unsigned: true })
	public fkObjectId!: number;

	@Column('varchar', { name: '_icon', length: 255 })
	public icon!: string;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@ManyToOne(() => ObjectEntity, (object) => object.importExportStores, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk__object__id', referencedColumnName: 'id' }])
	public fkObject!: ObjectEntity;
}
